import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { inject } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import {
  AppRoutePaths,
  AppRoutes,
} from "src/app/shared/common/app-path.routes";
import { MatToolbarModule } from "@angular/material/toolbar";
import { UserResult } from "src/app/shared/models/login.model";
import { GlobalServiceService } from "src/app/shared/services/global-service.service";

import { MatDrawerMode, MatSidenavModule } from "@angular/material/sidenav";
import { MatIconModule } from "@angular/material/icon";
import { LayoutModule } from "@angular/cdk/layout";
import { MatListModule } from "@angular/material/list";
import { RouterModule } from "@angular/router";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { FormControl } from "@angular/forms";
import { AdminDashboardComponent } from "../admin-dashboard/admin-dashboard.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FlyoutService } from "src/app/shared/services/flyout.service";
import {
  FlyoutApplicationEnum,
  FooterNameUrlEnum,
} from "src/app/shared/common/common.enum";
import { NotificationListComponent } from "../notification-list/notification-list.component";
import OktaAuth from "@okta/okta-auth-js";
import { OKTA_AUTH } from "@okta/okta-angular";
import { MatDialog } from "@angular/material/dialog";
import { TermsPageViewComponent } from "../terms-page-view/terms-page-view.component";
import { CdkAutofill } from "@angular/cdk/text-field";
import {
  ExternalUserRegistrationComponent,
  UserRegistrationDialogData,
} from "../external-user-registration/external-user-registration.component";
import { UsersService } from "src/app/api/users.service";

@Component({
  selector: "app-layout",
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    LayoutModule,
    MatListModule,
    RouterModule,
    FooterComponent,
    HeaderComponent,
    AdminDashboardComponent,
    MatFormFieldModule,
    NotificationListComponent,
  ],
  templateUrl: "./layout.component.html",
  styleUrl: "./layout.component.css",
})
export class LayoutComponent implements OnInit {
  loading = false;
  isMobile = false;
  userInfo?: UserResult;
  mode = new FormControl("over" as MatDrawerMode);
  hasBackdrop = new FormControl(null as null | boolean);
  position = new FormControl("end");
  private gbService = inject(GlobalServiceService);
  private flyoutService = inject(FlyoutService);
  private okta = inject<OktaAuth>(OKTA_AUTH);
  private dialog = inject(MatDialog);
  private users = inject(UsersService);
  flyoutHeader = "";
  appRoutePaths = AppRoutePaths;
  appRoutes = AppRoutes;
  isAdmin = false;
  flyoutApplicationsEnum = FlyoutApplicationEnum;
  openFlyout = "";
  appLink = FooterNameUrlEnum;
  // private dialog = inject(MatDialog);

  // closeFlyout = true;

  constructor() {
    this.isAdmin = this.gbService.userData()?.["isAdmin"] ?? false;
    this.isMobile = this.gbService.isMobile;
  }

  ngOnInit(): void {
    // this.flyoutHeader = this.gbService.flyoutHeaderSignal();
    this.flyoutHeader = this.flyoutService.flyoutHeaderSignal();
  }

  // async signOut() {
  //   this.okta.clearStorage();
  //   this.okta.clearDPoPStorage(true);
  //   this.okta.closeSession();
  //   this.okta.signOut({
  //     postLogoutRedirectUri: `http://localhost:4200/${
  //       AppRoutePaths[AppRoutes.Login]
  //     }`,
  //   });
  // }
  getFlyoutHeader(): string {
    return this.flyoutService.flyoutHeaderSignal();
  }
  closeFlyoutHandle() {
    this.flyoutService.isResetFlyout.set(false);
  }
  openFlyoutHandle(value: FlyoutApplicationEnum) {
    this.flyoutService.isResetFlyout.set(true);
    this.openFlyout = value;
    this.flyoutService.setFlyoutHeader(value);
  }
  onLogout() {
    this.oktaSignout();
  }

  private oktaSignout() {
    this.okta.clearStorage();
    this.okta.clearDPoPStorage(true);
    this.okta.closeSession();
    this.okta.signOut();
  }

  async onOpenTermsPopup() {
    try {
      this.loading = true;

      const email = this.getEmailFromSession();
      if (!email) {
        // Fallback if not logged in or missing
        // You can route to login or show a message
        this.loading = false;
        return;
      }

      this.loading = false;

      // Open modal with resolved prefill data
      const dialogRef = this.dialog.open(TermsPageViewComponent, {
        width: "900px",
        disableClose: true, // prevent closing by clicking backdrop
        panelClass: "brand-dialog",
        autoFocus: false,
        restoreFocus: true,
        backdropClass: "brand-backdrop",
        data: {},
      });

      // Optional: act on close
      dialogRef.afterClosed().subscribe((result) => {
        if (result?.saved) {
          // Refresh view or emit event
        }
      });
    } catch (err) {
      this.loading = false;
      // Show error UX
      console.error("Prefill failed", err);
    }
  }
  private getEmailFromSession(): string {
    return sessionStorage.getItem("UserEmail") ?? "";
  }

  clickExtRegistration(event: boolean) {
    if (event) {
      this.onOpenExtRegistration();
    }
  }

  async onOpenExtRegistration() {
    try {
      this.loading = true;

      const email = this.getEmailFromSession();
      if (!email) {
        // Fallback if not logged in or missing
        // You can route to login or show a message
        this.loading = false;
        return;
      }

      // :small_orange_diamond: API call BEFORE opening the modal
      const prefill = (await this.users.getAppUrl(1, "one").toPromise()) as any;

      this.loading = false;

      // Open modal with resolved prefill data
      const dialogRef = this.dialog.open(ExternalUserRegistrationComponent, {
        width: "560px",
        height: "750px",
        disableClose: true, // prevent closing by clicking backdrop
        panelClass: "brand-dialog",
        backdropClass: "brand-backdrop",
        data: {
          prefill: {
            email: prefill.email,
            displayName: prefill.displayName,
            department: prefill.department,
            roles: prefill.roles,
          },
        } as UserRegistrationDialogData,
      });

      // Optional: act on close
      dialogRef.afterClosed().subscribe((result) => {
        if (result?.saved) {
          // Refresh view or emit event
        }
      });
    } catch (err) {
      this.loading = false;
      // Show error UX
      console.error("Prefill failed", err);
    }
  }
}
